export const settings = {
    orderTypes: {
        name: 'orderTypes',
        requested: true,
        label: 'Art des Auftrags',
        options: [
            {
                id: 'createNewXPlanFormGivenData',
                name: 'Neues Planwerk im XPlan-Format erstellen',
                description:
                    'Neuen XPlan aus Planwerk (PDF, CAD, Shape, etc...) erstellen lassen.',
            },
            {
                id: 'createNewXPlanFromExistingPlan',
                name: 'Überführung eines bestehenden Bauleitplanes in das Format XPlanung',
                description:
                    'XPlan aus bereits existierenden Planwerk (PDF, CAD, Shape, etc...) erstellen lassen.',
            },
            {
                id: 'modifyGivenXPLln',
                name: 'Änderung/Eweiterung eines bestehenden Plans im XPlan-Format',
                description:
                    'Bereits bestehenden Plan im XPlan-Format ändern oder erweitern lassen.',
            },
        ],
    },
    plotArea: {
        id: 'plotArea',
        name: 'plotArea',
        label: 'Größe des Plangebiets',
        requested: false,
        unit: 'ha',
    },
    name: {
        id: 'name',
        name: 'name',
        label: 'Bezeichnung des Auftrags',
        requested: true,
        unit: null,
    },
    deadline: {
        id: 'deadline',
        name: 'deadline',
        label: 'Lieferdatum des Auftrags',
        requested: false,
        unit: null,
    },
    legalPlanStatus: {
        id: 'legalPlanStatus',
        name: 'legalPlanStatus',
        label: 'Rechtsstand des Plans',
        requested: false,
        options: [
            {
                id: '1000',
                name: '(1000) Ein Aufstellungsbeschluss der Gemeinde liegt vor',
            },
            { id: '2000', name: '(2000) Ein Planentwurf liegt vor' },
            {
                id: '2100',
                name: '(2100) Die frühzeitige Beteiligung der Behörden (§ 4 Abs. 1 BauGB) hat stattgefunden',
            },
            {
                id: '2200',
                name: '(2200) Die frühzeitige Beteiligung der Öffentlichkeit hat stattgefunden',
            },
            {
                id: '2300',
                name: '(2300) Die Beteiligung der Behörden hat stattgefunden (§ 4 Abs. 2 BauGB)',
            },
            {
                id: '2400',
                name: '(2400) Der Plan hat öffentlich ausgelegen (§ 3 Abs. 2 BauGB)',
            },
            {
                id: '3000',
                name: '(3000) Die Satzung wurde durch Beschluss der Gemeinde verabschiedet',
            },
            { id: '4000', name: '(4000) Der Plan ist in Kraft getreten' },
        ],
    },
    requestedXPlanVersion: {
        id: 'requestedXPlanVersion',
        name: 'requestedXPlanVersion',
        label: 'Gewünschte XPlan Version',
        requested: false,
        default: "5.4",
        options: [
            { id: '5.0.1', name: '5.0.1' },
            { id: '5.1.2', name: '5.1.2' },
            { id: '5.3', name: '5.3' },
            { id: '5.4', name: '5.4 (Standard)' },
            { id: '6.0.2', name: '6.0.2' },
        ],
    },
    textualDeterminations: {
        id: 'textualDeterminations',
        name: 'textualDeterminations',
        label: 'Textliche Festsetzungen',
        requested: false,
        options: [
            {
                id: 'asTextSectionsOnObjects',
                name: 'Als Textabschnitte an Objekten',
            },
            {
                id: 'asExternalReferenceToScope',
                name: 'Als externe Referenz am Geltungsbereich',
            },
        ],
    },
    depthOfCoverage: {
        id: 'depthOfCoverage',
        name: 'depthOfCoverage',
        label: 'Erfassungstiefe',
        requested: false,
        options: [
            { id: 'fullVector', name: 'Vollvektoriell' },
            { id: 'rasterEncircling', name: 'Raster-Umring' },
        ],
    },
    procedure: {
        id: 'procedure',
        name: 'procedure',
        label: 'Verfahren',
        requested: false,
        options: [
            { id: '1000', name: '(1000) Normales BPlan Verfahren' },
            { id: '2000', name: '(2000) BPlan Verfahren nach § 13 BauGB' },
            { id: '3000', name: '(3000) BPlan Verfahren nach § 13a BauGB' },
            { id: '4000', name: '(4000) BPlan Verfahren nach § 13b BauGB' },
        ],
    },
    projection: {
        id: 'projection',
        name: 'projection',
        label: 'Gewünschte Projektion',
        requested: false,
        options: [
            { id: 'EPSG:31466', name: 'Gauss-Kruger Zone 2' },
            { id: 'EPSG:25832', name: 'UTM zone 32N' },
            { id: 'EPSG:32633', name: 'UTM zone 33N' },
            { id: 'EPSG:4326', name: 'WGS84 - World Geodetic System 1984' },

        ],
    },
    planType: {
        id: 'planType',
        name: 'planType',
        label: 'Zu erstellendes Planwerk',
        requested: true,
        options: [
            { id: 'developmentPlan', name: 'Bebauungsplan' },
            { id: 'landUsePlan', name: 'Flächennutzungsplan' },
            { id: 'spatialPlanning', name: 'Raumordnungplan' },
            { id: 'landscapePlan', name: 'Landschaftsplan' },
            { id: 'otherPlan', name: 'Sonstiges Planwerk' },
        ],
    },
    additionalInformation: {
        id: 'additionalInformation',
        name: 'additionalInformation',
        label: 'Zusätzliche Informationen',
        requested: false,
        unit: null,
    },
    otherRequirements: {
        id: 'otherRequirements',
        name: 'otherRequirements',
        label: 'Sonstige Anforderungen',
        requested: false,
        options: [
            { id: '1000', name: 'Bemaßungen als Objekte erfassen' },
            { id: '2000', name: 'Bestandsdarstellungen erfassen' },
            { id: '3000', name: 'Änderungs-GML abhängiger Planwerke' },
            { id: '4000',name: 'Übersetzungskonzept für nicht-standardisierte Planzeichen',},
            { id: '5000', name: 'Bereinigung der Ausgangsdaten' },
        ],
    },
    community: {
        id: 'community',
        name: 'community',
        label: 'Gemeinde',
        requested: true,
    },
    communityKey: {
        id: 'communityKey',
        name: 'communityKey',
        label: 'Gemeindeschlüssel',
        requested: true,
    }
};
